import React from "react";
import { fw500, primaryTextColor } from "../../../Global.module.css";
import {
	center,
	left,
	right,
} from "../../editorPage/LayoutBlocks/Alignment.module.css";
import styles from "./Block.module.css";

export default function Title({ title, alignment }) {
	const alignments = {
		center: center,
		left: left,
		right: right,
	};
	return (
		<div className={styles.title}>
			<p
				className={`${fw500} ${primaryTextColor} ${
					alignments[alignment] || left
				}`}
			>
				{title}
			</p>
		</div>
	);
}
